import gql from 'graphql-tag';
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';

export const CREATE_PLANOGRAM_ROW = gql`
	mutation createPlanogramRowMutation(
		$planogramId: ID,
		$planogramItemGroupId: ID,
		$row: Int,
	) {
		createPlanogramRow (
			planogramId: $planogramId,
			planogramItemGroupId: $planogramItemGroupId,
			row: $row,
		) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;

